export const handleShowUnderEditInfoOnCardOrListItem = ({
  content,
  config,
}) => {
  
  const infoText =
    content.kp_published_status === "underModeration"
      ? `Under review by ${content?.kp_moderator?.name}`
      : !!content.editPublishedDocId && !!content.currentEditor
      ? `Under edit by ${content?.meta?.kp_contributed_by?.name}`
      : undefined;

  if (infoText) {
    return {
      content: {
        ...content,
        underEditInfoText: infoText,
      },
      config: {
        ...config,
        tagDisplay: 'underEditInfoText'
      },
      extraProps: {
        statusTagColorPreset: 'warning'
      }
    };
  } else {
    return { config, content };
  }
};
